<template>
    <div class="mt-2">
        <div class="card">
            <div class="card-header bg-success text-white">Añadir campo</div>
            <div class="card-body">
                <form @submit.prevent="store(field)">
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="">Nombre: </label>
                            <input v-model="field.name" type="text" required class="form-control">
                        </div>
                        <div class="col-12">
                            <input type="submit" class="float-right btn btn-success" value="Guardar">
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: "AddField",
    data: () => ({
        field: {},
    }),
    methods: {
        emptyField(){
            this.field = {name: ""};
        },
        store(field){
            this.storeField(field),
            this.emptyField();
        },
        ...mapActions(['storeField'])
    }
}
</script>

<style>

</style>